<app-sg-aria-message [errorMessageModelArray]="errorMessageModelArray"></app-sg-aria-message>
<h1>包括契約検索</h1>

<!-- Select what to search -->
<mat-expansion-panel class="mat-expansion-panel" [expanded]="true">
  <mat-expansion-panel-header>
    <mat-panel-title class="title">検索条件</mat-panel-title>
  </mat-expansion-panel-header>
  <div>
    <form (ngSubmit)="onSubmit()" [formGroup]="kensakuJyoukenForm">
      <!-- 検索条件コンポーネント -->
      <app-sgkb701d-search-condition (onClickButtonEvent)="setValue($event)" [mode]="mode">
      </app-sgkb701d-search-condition>
    </form>
  </div>
</mat-expansion-panel>

<div *ngIf="showResult && !clearExeFlg">
  <mat-card class="cur-card">
    <!-- 検索結果コンポーネント -->
    <app-sgkb701d-search-result (rowClickEvent)="onClickRow($event)" [mode]="mode" [incCtrSearchResultList]="incCtrSearchResultList">
    </app-sgkb701d-search-result>
  </mat-card>
</div>
